import * as React from 'react';
import { IHeadingSubNav } from '../utils/declarations';
import { globalHistory } from '@reach/router';

export interface ISubnavContext {
  subnav?: IHeadingSubNav[];
  updateSubnav: (subnav: IHeadingSubNav[]) => void;
}

const DEFAULT_STATE = {
  subnav: null,
  updateSubnav: () => null,
};

export const SubnavContext = React.createContext<ISubnavContext>(DEFAULT_STATE);

export const SubnavProvider: React.FunctionComponent = ({ children }) => {
  const [subnav, setSubnav] = React.useState([]);

  // Reset subnav on route change
  React.useEffect(() => {
    return globalHistory.listen(({ action }) => {
      if (action === 'PUSH') setSubnav([]);
    });
  }, [setSubnav]);

  // allow update from page components
  const updateSubnav = React.useCallback(
    (subnavUpdate: IHeadingSubNav[]) => {
      setSubnav(subnavUpdate);
    },
    [subnav, setSubnav],
  );

  return (
    <SubnavContext.Provider value={{ subnav, updateSubnav }}>{children}</SubnavContext.Provider>
  );
};

export const useSubnav = () => React.useContext(SubnavContext);

export const SubnavConsumer = SubnavContext.Consumer;
